<template>
  <vs-popup class="customer-sample-order-create-popup"
            title="PRODUCT ORDER ITEMS UPDATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card  no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="popup" @submit.prevent="handleSubmit(onClickCreateSampleOrder)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full md:s-full w-full md:mb-0">
              <vs-table :data="cartItems" stripe>
                <template slot="header">
                  <h3>
                    <span class="text-danger text-lg mb-8">Available credit (GBP):  <b>{{creditDetails.credit_limit}}</b></span>
                  </h3>
                </template>
                <template slot="thead">
                  <vs-th width="15%">CODE</vs-th>
                  <vs-th width="15%">QUANTITY</vs-th>
                  <vs-th width="15%">UNIT PRICE (KG)</vs-th>
                  <vs-th width="15%">TOTAL PRICE ({{__accountCurrency()}})</vs-th>
                  <vs-th width="20%">ACTIONS</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].formulation_code">
                      {{ data[indextr].formulation_code }}
                    </vs-td>

                    <vs-td :data="data[indextr].quantity">
                      <ValidationProvider :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'required'" v-slot="{ errors }">
                        <vs-input :disabled="!['Pending', 'Submitted'].includes(data[indextr].item_status)" v-on:input="onChangeQty(data[indextr])" type="text" v-model="data[indextr].quantity" class="w-full"
                                  :name="'quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </vs-td>
                    <vs-td :data="data[indextr].price">
                      {{ data[indextr].price }}
                    </vs-td>

                    <vs-td :data="data[indextr].price">
                      {{data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                    </vs-td>

                    <vs-td :data="data[indextr].formulation_id">
                      <div class="vx-row">
                        <vx-tooltip class="mr-2" text="Remove cart" position="left">
                          <vs-button :disabled="!['Pending', 'Submitted'].includes(data[indextr].item_status)" @click="onClickRemoveFromCart(indextr)"
                                     size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>

                  </vs-tr>
                  <vs-tr>
                    <vs-td style="font-weight: bolder">Total</vs-td>
                    <vs-td></vs-td>
                    <vs-td></vs-td>
                    <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>
                    <vs-td></vs-td>
                  </vs-tr>
                </template>

              </vs-table>
            </div>

          </div>
          <!-- Save & Reset Button -->
<!--          <div class="flex flex-wrap items-center justify-end mt-8">-->
<!--            <vs-button button="submit" class="ml-auto mt-2">Order</vs-button>-->
<!--            <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>-->
<!--          </div>-->
        </form>
      </ValidationObserver>
    </vx-card>
    <create-customer-account-limit-request-pop-up ref="createCustomerAccountLimitRequestPopUp" />
    <customer-credit-check-pop-up
      v-on:openCreditLimitRequest="openCreditLimitRequest"
      v-on:refreshData="onlyRefreshData"
      v-on:onlyRefreshData="onlyRefreshData"
      ref="customerCreditCheckPopUp"/>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  import CustomerCreditCheckPopUp from '@/components/popups/customer/product-orders/CustomerCreditCheckPopUp'
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction: '',
        formulation_items: []
      },
      countryCodes: [],
      customerUsers: [],
      isCreateFromMainMenu: false,
      customers: [],
      formulations: [],
      addresses: [],
      selectedAddress: '',
      cartItems: [],
      productCatalogues: [],
      onClickAddressChange: true,
      creditDetails: {

      }
    }
  }

  export default {
    name: 'TrackingImagePopUp',
    data () {
      return initialState()
    },
    methods:{
      async openPopup (id) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          this.open = true;
          await this.getItemsInItemsCart()
          // this.getFormulations()

        } catch (error) {

        }
      },
      async refreshData() {
        this.open =false
      },
      async onlyRefreshData() {
        await this.getItemsInItemsCart()
      },
      async openCreditLimitRequest() {
        await this.onlyRefreshData()
        await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup(this.id)
      },
      async onClickClose() {
        this.open = false
        this.$emit('refreshItems')
      },
      async onClickCreateSampleOrder () {
        const vue = this;
        this.$vs.loading()
        try {
          this.form.customer_id = this.id
          this.form.formulation_items = this.cartItems.map((m) => {
            return { id: m.formulation_id, quantity: m.quantity, price: (Number(m.price)).toFixed(2), type: m.type}
          })

          await CustomerRepository.createCustomerProductOrder(this.form)
          this.showSuccessMessage('Product order created successfully')
          this.open = false;
          await vue.$parent.refreshData()

        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async getItemsInItemsCart() {
        await this.$vs.loading({
          container: '#popup',
          scale: 0.45
        })
        try {
          const {data} = (await CustomerRepository.getCustomerProductOrder(this.id)).data
          this.cartItems = data.formulation_items
          this.creditDetails = data.customer_account_credit
          // this.productCatalogues = (await CustomerRepository.getListOfProductCatalogue(this.customerId, '')).data.data
          // this.cartItems = this.cartItems.map((n) => {
          //   const find =  this.productCatalogues.find((m) => n.id === m.id)
          //   n.min_order_quantity = find.min_order_quantity
          //   return n
          // })
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#popup > .con-vs-loading')
      },
      async onClickRemoveFromCart(indextr) {
        this.cartItems.splice(indextr, 1)
        await this.onClickUpdateFromCart()
      },
      async onClickUpdateFromCart() {
        await this.$vs.loading({
          container: '#popup',
          scale: 0.45
        })
        try {
          const payload = {formulation_items : this.cartItems.map((n) => {
              return  {id: n.formulation_id, price: n.price, quantity: n.quantity, type: n.type}
            })}
          await CustomerRepository.updateProductOrderContent(this.id, payload)
          await this.getItemsInItemsCart()
          this.showSuccessMessage('Product item quantity updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#popup > .con-vs-loading')
      },
      onChangeSelectDeliveryAddress(selected) {
        this.form.line1 = selected.line1
        this.form.line2 = selected.line2
        this.form.line3 = selected.line3
        this.form.town_state = selected.town_state
        this.form.post_code = selected.post_code
        this.form.country = selected.country
        this.onClickAddressChange = false
      },
      totalCalculator() {
        let total = 0;
        this.cartItems.forEach((m) => {
          if (!!m.price) {
            total = total + Number(m.price) * Number(m.quantity)
          }

        })
        return total.toFixed(2)
      },
      onChangeQty(data) {
        if (Number(data.quantity) > 0 ) {
          this.updateCart(data, this)
        }
      },
      updateCart: _.debounce( async (data, vm) => {

        if (!vm.isCanAddOrderWithCredit()) {
          await vm.openCreditCheckPopUp()
          return null
        }

        await vm.onClickUpdateFromCart(data)
      }, 500),
      isCanAddOrderWithCredit() {
        if(this.creditDetails.account_type === 'proforma') {
          return true
        }
        const cart_total = this.totalCalculator()
        const credit_limit = this.creditDetails.credit_limit
        return Number(cart_total) < Number(credit_limit)
      },
      async openCreditCheckPopUp() {
        await this.$refs.customerCreditCheckPopUp.openPopup()
      }


    },
    computed: {

    },
    components: {
      'v-select': vSelect,
      CustomerCreditCheckPopUp,
      CreateCustomerAccountLimitRequestPopUp
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    /*min-height: 80% !important;*/
    min-width: 60% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
